/**
 * CORE-1685 — текст с эмодзи комплекта внутри: токены `:agape_N:` рисуются
 * картинками в строке, остальное — как отдал `render` (ссылки, разметка).
 * Вкладывается в уже открытый <Text>, поэтому сам <Text> не создаёт.
 */
import React from 'react';
import type { ImageStyle, StyleProp } from 'react-native';
import { parseEmojiTokens } from '../../utils/emojiTokens';
import { ReactionGlyph } from './ReactionGlyph';

interface Props {
  text: string;
  /** Как рисовать обычный кусок текста; по умолчанию — как есть. */
  render?: (chunk: string, index: number) => React.ReactNode;
  /** Сторона картинки; по умолчанию под строку 24px. */
  size?: number;
  /** CORE-1791 — поля картинки в строке (раздел сообщений: по 2px с боков). */
  glyphStyle?: StyleProp<ImageStyle>;
}

export const EmojiText: React.FC<Props> = ({ text, render, size = 22, glyphStyle }) => {
  const segments = parseEmojiTokens(text);
  if (segments.length === 0) return null;
  return (
    <>
      {segments.map((seg, i) => (seg.type === 'text' ? (
        <React.Fragment key={`t-${i}`}>{render ? render(seg.value, i) : seg.value}</React.Fragment>
      ) : (
        <ReactionGlyph key={`e-${i}`} type={seg.reaction} size={size} inline style={glyphStyle} />
      )))}
    </>
  );
};
